import { UtcDate } from '@/helpers/date';

export default {
  validate: (value, { yearOfManufacture }) => {
    if (!value) {
      return {
        required: true,
        valid: false,
      };
    }

    const vehicleBoughtDateUtc = new UtcDate(value);

    if (!vehicleBoughtDateUtc.isValid()) {
      return {
        required: true,
        valid: false,
      };
    }

    // Only validate against the yearOfManufacturer if it is present in some cases it may be null
    // eg. on Gap for some vehicles as the vehicle selector is not used
    if (yearOfManufacture) {
      const yearOfManufactureDateUtc = new UtcDate(yearOfManufacture);

      if (
        !yearOfManufactureDateUtc.isValid() ||
        vehicleBoughtDateUtc.isBefore(yearOfManufactureDateUtc)
      ) {
        return {
          required: true,
          valid: false,
        };
      }
    }

    return {
      required: true,
      valid: true,
    };
  },
  params: ['yearOfManufacture'],
  message: (fieldName, { _value_: value, yearOfManufacture }) => {
    const defaultMsg = 'Please enter the month & year the vehicle was bought.';
    if (!value) return defaultMsg;

    const vehicleBoughtDateUtc = new UtcDate(value);

    if (!vehicleBoughtDateUtc.isValid()) return defaultMsg;

    const yearOfManufactureDateUtc = new UtcDate(yearOfManufacture);

    if (
      !yearOfManufactureDateUtc.isValid() ||
      yearOfManufactureDateUtc.isAfter(vehicleBoughtDateUtc)
    ) {
      return 'Vehicle buy date can\'t be earlier than year of vehicle manufacture.';
    }

    return defaultMsg;
  },
  computesRequired: true,
};
